import React, {FC, ReactElement} from "react";
import {Form} from "antd";
import type {FormItemProps} from "antd";
import {FieldTile} from "../../../Components/ui";

// An antd Form field laid out as a FieldTile; validation messages render under the control.
export const ParticipantFormField: FC<{
    label: string;
    name: FormItemProps["name"];
    rules?: FormItemProps["rules"];
    children: ReactElement;
}> = ({label, name, rules, children}) => (
    <FieldTile label={label}>
        <Form.Item name={name} rules={rules} style={{marginBottom: 0}}>
            {children}
        </Form.Item>
    </FieldTile>
);
